import Lenis from 'lenis';

let lenis = null;

export function initSmoothScroll() {
  if (lenis) return lenis;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return null;

  lenis = new Lenis({ duration: 1.15, smoothWheel: true });

  const raf = (time) => {
    lenis.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);

  document.addEventListener('click', (e) => {
    const anchor = e.target.closest('a[href^="#"]');
    if (!anchor) return;
    const hash = anchor.getAttribute('href');
    if (!hash || hash.length < 2) return;
    const el = document.querySelector(hash);
    if (!el) return;
    e.preventDefault();
    lenis.scrollTo(el, { offset: -76 });
  });

  return lenis;
}

export function scrollToSection(hash) {
  const el = document.querySelector(hash);
  if (!el) return;
  if (lenis) {
    lenis.scrollTo(el, { offset: -76 });
  } else {
    el.scrollIntoView({ behavior: 'smooth' });
  }
}

export function lockScroll() {
  if (lenis) lenis.stop();
  document.body.style.overflow = 'hidden';
}

export function unlockScroll() {
  if (lenis) lenis.start();
  document.body.style.overflow = '';
}
